export default __webpack_public_path__ + "static/media/esg-23.7d459ae9.jpg";